<div>
  <mat-icon
    class="cursor-pointer align-middle scale-[.6]"
    (click)="previousPeriodClick()"
    >arrow_back_ios</mat-icon
  >
  <span class="!text-slate-400"
    >{{ periodService.current.year }} / {{ periodService.current.month }}</span
  >
  <mat-icon
    class="cursor-pointer align-middle scale-[.6]"
    (click)="nextPeriodClick()"
    >arrow_forward_ios</mat-icon
  >
</div>
